import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addIncoterm } from "../../../store/actions"
import { useEffect } from "react"

const AddIncoterm = props => {
  const dispatch = useDispatch()
  document.title = "Add Incoterm"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      incoterm_city: "",
    },
    validationSchema: Yup.object({
        incoterm_city: Yup.string().required(
        "Please Enter Incoterm City"
      ),
    }),
    onSubmit: values => {
      dispatch(addIncoterm(values, props.history))
    },
  })

  const inco = useSelector(state => state.incotermCity)
  const { error } = useSelector(state => ({
    error: state.incotermCity.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Incoterm City" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formInco"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="incoterm">
                            Incoterm City
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="incoterm_city"
                            className={
                              validation.touched.incoterm_city &&
                              validation.errors.incoterm_city
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="incoterm"
                            placeholder="Enter Incoterm City"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.incoterm_city || ""}
                          />
                          {validation.touched.incoterm_city &&
                          validation.errors.incoterm_city ? (
                            <FormFeedback type="invalid">
                              {validation.errors.incoterm_city}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {inco && inco.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddIncoterm
